module.exports = __webpack_public_path__ + "static/media/Credits-15.a8fe67b8.pdf";